export default {
  title: {
    marginTop: "16px",
    marginBottom: "8px",
  },
  instructions: {
    marginBottom: "16px",
    display: "block",
  },
  selectContainer: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "16px",
    marginBottom: "16px",
  },
  fieldContainer: {
    marginBottom: "16px",
  },
  sectionTitle: {
    marginTop: "8px",
    marginBottom: "16px",
    fontWeight: "bold",
  },
  twoColumnGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "16px",
    marginBottom: "16px",
  },
  threeColumnGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "16px",
    marginBottom: "16px",
  },
};
